<template>
  <q-bar
    dense
    :class="`col-auto bg-${frequency.color} text-white justify-center`"
    v-if="frequency.text"
  >
    <div class="col text-center text-weight-bold">
      {{ frequency.text }}
    </div>
  </q-bar>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    attendanceId: {}
  },

  mounted () {
    this.loadFrequency(this.attendanceId)
  },

  computed: {
    ...mapState({
      frequency ({ attendanceModule: state }) {
        const vm = this
        let attendance = null
        if (!attendance && state.current[vm.attendanceId]) attendance = state.current[vm.attendanceId]
        if (!attendance && state.history[vm.attendanceId]) attendance = state.history[vm.attendanceId]
        if (attendance?.direction !== 'IN') return {}
        return attendance?.frequency ?? {}
      }
    })
  },

  methods: {
    ...mapActions({
      loadFrequency: 'attendanceModule/loadFrequency'
    })
  }
}

</script>
